/**
 * License Intelligence SAP Snapshot Mock Data
 *
 * Mock data for the snapshot ribbon API endpoint.
 * In production, this data will come from:
 * GET /ECMv6/api/sodms/license-intelligence/v1/sap/snapshot
 */

export interface SnapshotTrend {
  direction: 'up' | 'down' | 'flat';
  value: number;
  label: string;
}

export interface SnapshotMetric {
  value: number;
  displayValue: string;
  trend: SnapshotTrend;
  estimated: boolean;
  threshold?: string;
  hasSimulation?: boolean;
}

export interface SnapshotData {
  totalLicenseSpend: SnapshotMetric;
  licenseUtilization: SnapshotMetric;
  costPerUser: SnapshotMetric;
  potentialSavings: SnapshotMetric;
  defaultMode: boolean;
  usageDataAvailable: boolean;
  lastUpdated: string;
}

export interface SnapshotResponse {
  data: SnapshotData;
  status: number;
  message: string;
}

export const LICENSE_INTELLIGENCE_SNAPSHOT_DATA: SnapshotResponse = {
  data: {
    totalLicenseSpend: {
      value: 4400000,
      displayValue: '$4.4M',
      trend: { direction: 'up', value: 3.6, label: '+3.6%' },
      estimated: false,
    },
    licenseUtilization: {
      value: 81,
      displayValue: '81%',
      trend: { direction: 'up', value: 2.1, label: '+2.1%' },
      threshold: 'amber',
      estimated: false,
    },
    costPerUser: {
      value: 2874,
      displayValue: '$2,874',
      trend: { direction: 'up', value: 3.2, label: '+3.2%' },
      estimated: false,
    },
    potentialSavings: {
      value: 144000,
      displayValue: '$144k',
      trend: { direction: 'down', value: 5.2, label: '-5.2%' },
      hasSimulation: true,
      estimated: false,
    },
    defaultMode: false,
    usageDataAvailable: true,
    lastUpdated: '2026-05-10T22:05:00Z',
  },
  status: 200,
  message: 'Snapshot ribbon data retrieved successfully',
};

export default LICENSE_INTELLIGENCE_SNAPSHOT_DATA;
